document.addEventListener('DOMContentLoaded', ()=>{
    const demoElements = document.querySelectorAll('.js-demo');
    demoElements.forEach((el)=>el.addEventListener('click', $4b4006c95d6a9e94$var$onDemoClick));
    const contactElements = document.querySelectorAll('.js-contact');
    contactElements.forEach((el)=>el.addEventListener('click', $4b4006c95d6a9e94$var$onContactClick));
    const clientElements = document.querySelectorAll('.js-client');
    clientElements.forEach((el)=>el.addEventListener('click', $4b4006c95d6a9e94$var$onClientClick));
});
function $4b4006c95d6a9e94$var$onContactClick(event) {
    const tool = event.currentTarget.dataset.tool;
    const domain = new URL(event.currentTarget.getAttribute('href')).hostname.replace('www.', '');
    window.fbq('track', 'Lead');
    window.rdt('track', 'Lead');
    window.gtag('event', 'contact', {
        contact_tool: tool,
        link_domain: domain
    });
}
function $4b4006c95d6a9e94$var$onDemoClick() {
    window.gtag('event', 'demo');
    window.fbq('trackCustom', 'demo');
    window.rdt('track', 'Custom', {
        customEventName: 'demo'
    });
}
function $4b4006c95d6a9e94$var$onClientClick() {
    window.gtag('event', 'demo');
    window.fbq('trackCustom', 'demo');
    window.rdt('track', 'Custom', {
        customEventName: 'demo'
    });
}


document.addEventListener('DOMContentLoaded', ()=>{
    const swiper = document.querySelector('.swiper');
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    if (isMobile || !swiper) return;
    const leftBtn = swiper.querySelector('.swiper__btn:first-of-type');
    const rightBtn = swiper.querySelector('.swiper__btn:last-of-type');
    const scrollingList = swiper.querySelector('.swiper__list');
    scrollingList.addEventListener('scroll', adjustScrollControls);
    window.addEventListener('resize', adjustScrollControls);
    leftBtn.addEventListener('click', scrollToLeft);
    rightBtn.addEventListener('click', scrollToRight);
    adjustScrollControls();
    function scrollToLeft() {
        scrollingList.scrollTo({
            left: scrollingList.scrollLeft - scrollingList.offsetWidth,
            behavior: 'smooth'
        });
    }
    function scrollToRight() {
        scrollingList.scrollTo({
            left: scrollingList.scrollLeft + scrollingList.offsetWidth,
            behavior: 'smooth'
        });
    }
    function adjustScrollControls() {
        const isRightEnd = Math.round(scrollingList.scrollLeft) >= scrollingList.scrollWidth - scrollingList.offsetWidth - 1;
        const isLeftEnd = Math.round(scrollingList.scrollLeft) <= 0;
        rightBtn.toggleAttribute('disabled', isRightEnd);
        leftBtn.toggleAttribute('disabled', isLeftEnd);
    }
});


document.addEventListener('DOMContentLoaded', ()=>{
    /* Adding a link to the home page instead of a link to the current page in the footer */ const currentPage = window.location.pathname;
    const footerLegal = document.querySelector('.footer__legal');
    const currentLink = footerLegal.querySelector(`a[href*="${currentPage}"]`);
    if (currentPage !== '/' && currentPage !== '/index.html' && currentLink) {
        footerLegal.removeChild(currentLink);
        const homeLink = document.createElement('a');
        homeLink.href = '/';
        homeLink.text = 'Home';
        footerLegal.insertAdjacentElement('afterbegin', homeLink);
    }
});




//# sourceMappingURL=index.26fc49f3.js.map
